var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTerminal = function SvgTerminal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5H21.5C21.7652 3.5 22.0196 3.60536 22.2071 3.79289C22.3946 3.98043 22.5 4.23478 22.5 4.5V20.5C22.5 20.7652 22.3946 21.0196 22.2071 21.2071C22.0196 21.3946 21.7652 21.5 21.5 21.5H3.5C3.23478 21.5 2.98043 21.3946 2.79289 21.2071C2.60536 21.0196 2.5 20.7652 2.5 20.5V4.5C2.5 4.23478 2.60536 3.98043 2.79289 3.79289C2.98043 3.60536 3.23478 3.5 3.5 3.5ZM4.5 5.5V19.5H20.5V5.5H4.5ZM12.5 15.5H18.5V17.5H12.5V15.5ZM9.167 12.5L6.338 9.672L7.753 8.257L11.995 12.5L7.753 16.743L6.338 15.328L9.167 12.5Z"
  })));
};
export default SvgTerminal;